import * as React from 'react';
import {
    Controller,
    Toolbar,
    MainMenu,
    Menu,
} from '@tencent/workbench';
import { TailorPicFeature } from './tailor-pic-feature';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import { TAILOR_PIC_NORMAL_WITHOUT_ICON } from '@src/framework/workbench/schema/top-menu';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class TailorPicController {
    constructor(private readonly feature: TailorPicFeature) {
    }

    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick')
    @Menu(config.id, 'onClick')
    @Menu(ActionType.TAILOR_PIC_NORMAL, 'onClick')
    @Menu(TAILOR_PIC_NORMAL_WITHOUT_ICON, 'onClick')
    public onClick() {
        const type = this.feature.getSelectModel()?.type;
        if (type && [UIModelType.IMAGE, UIModelType.SHAPE].includes(type)) {
            this.feature.callbackByActionType(ActionType.TAILOR_PIC_NORMAL);
        }
    }

    @Menu(MenuKey.TAILOR_PIC_SHAPE_CONTAINER, 'shouldHide')
    @Menu(MenuKey.TAILOR_PIC_WH, 'shouldHide')
    public shouldMenuHide() {
        return this.feature.shouldMenuHide();
    }

    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    public shouldHide() {
        return this.feature.shouldHide(config.id);
    }

    @Toolbar(ActionType.MULTI_TAILOR_PIC, 'shouldHide')
    @Toolbar(wrapIdForBig(ActionType.MULTI_TAILOR_PIC), 'shouldHide')
    public shouldMultiHide() {
        return this.feature.shouldHide();
    }

    @Toolbar(config.id, 'onArrowClick')
    @Toolbar(wrapIdForBig(config.id), 'onArrowClick')
    public onArrowClick() {
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    @Toolbar(ActionType.MULTI_TAILOR_PIC, 'dropdownContent')
    @Toolbar(wrapIdForBig(ActionType.MULTI_TAILOR_PIC), 'dropdownContent')
    public insertDropdown() {
        return <MainMenu align="left" name={config.id} mode="menu" itemStyle={{ width: 166 }} />;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    @Toolbar(wrapIdForBig(config.id), 'onDropdownVisibleChange')
    @Toolbar(ActionType.MULTI_TAILOR_PIC, 'onDropdownVisibleChange')
    @Toolbar(wrapIdForBig(ActionType.MULTI_TAILOR_PIC), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }
}

